<template>
  <Maintenance v-if="!etatEnv" />

  <Spinner v-if="load || loadTempo" />

  <ChooseConfigurator  v-if="!load && !loadTempo && etatEnv && !chooseConfig" 
  :initialData="autreConfigUrl"
      @dataSent="handleDataSent"
       />

  <Header v-if="!load && !loadTempo && chooseConfig && etatEnv && $store.state.storeGlobal.StoreEnvWeb != 'Webshop' && $store.state.storeGlobal.StoreEnvWeb != 'Formulaire'" />


  <Configurateur v-if="!load && !loadTempo && etatEnv && chooseConfig" />

  <!-- <Footer   v-if="!load && etatEnv" /> -->
</template>

<style src="./assets/css/index.css"></style>
<style src="./assets/css/no-mobile.css"></style>
<style src="./assets/css/mobile.css"></style>

<script>
import Configurateur from './components/configurateur/Configurateur.vue'
import Header from './components/navigation/Header.vue'
//import Footer from './components/navigation/Footer.vue'
import Spinner from './components/loader/LoaderPoint.vue'
import Maintenance from './components/message/Maintenance.vue'
import ChooseConfigurator from './components/loader/ChooseConfigurator.vue'

export default {
  components: {
    Header,
    Configurateur,
    ChooseConfigurator,
    //Footer,
    Spinner,
    Maintenance,
  },
  data() {
    return {
      etatEnv: true,
      load: true,
      chooseConfig: true,
      loadTempo: true,
      envWebNAme: true,
      autreConfigUrl : false
    }
  },
  mounted() {
    // alert(document.referrer);
    // set the default user session
    // todo generate a random user session id
    const sessionId = function () {
      return 'GIG' + Math.random().toString(36).substr(3).toUpperCase();
    }
    this.$store.commit('SET_SESSIONID', sessionId())
    window.addEventListener('message', this.setUser)

    this.initConfigurateur();

    //this.envWebNAme = this.$store.state.storeGlobal.StoreEnvWeb

  },
  beforeUnmount() {
    window.removeEventListener('message', this.setUser)

  },
  created() {

    setTimeout(() => this.loadTempo = false, 2000);


  },
  methods: {
    handleDataSent(data) {
      this.chooseConfig = data;
    },
    async initConfigurateur() {
      await this.initJwtToken();
      await this.loadEnvWeb();
      await this.initLanguage();
      await this.loadReductionPays();
    },
    //Initialise le JWT token pour accés à l'API
    async initJwtToken() {
      const data = {
        username: this.$store.state.storeGlobal.StoreApiUsername,
        password: this.$store.state.storeGlobal.StoreApiPassword
      };
      const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/login_check', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      var resultToken = (await res.json());
      // console.log(resultToken);
      this.$store.state.storeGlobal.StoreJwtToken = 'Bearer ' + resultToken.token
      // console.log("test");
    },
    async loadReductionPays() {
      try {
        const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/pays?nom='+this.$store.state.storeGlobal.StorePays, {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": this.$store.state.storeGlobal.StoreJwtToken
          },
        })
        var resultApi = (await res.json());
        this.$store.state.storeGlobal.StoreReductionPays = resultApi[0]['reducActive']
        this.$store.state.storeGlobal.StoreReductionMessage = resultApi[0]['message_promo']
      } catch (error) {
        // console.log('Error! Could not reach the API. ' + error);
        this.answer = 'Error! Could not reach the API. ' + error
      }
    },
    async loadEnvWeb() {
      try {
        var query = 'nom=' + this.$store.state.storeGlobal.StoreEnvWeb;
        const userAgent = navigator.userAgent;
        if (userAgent.includes("Firefox")) {
          // Le navigateur est Firefox
          if (document.referrer) {
            const urlParentBase = new URL(document.referrer).hostname.replace("www.", "");
            const urlParent = urlParentBase.replace("www.", "");
            query = 'url=' + urlParent;
          }

        } else {
          // Le navigateur est autre que firefox
          if (typeof document.location.ancestorOrigins !== 'undefined') {

            const urlParentBase = document.location.ancestorOrigins[0].replace("https://", "");
            const urlParent = urlParentBase.replace("www.", "");
            //console.log(urlParent);
            query = 'url=' + urlParent;

          }

        }
        console.log('url ' + query.substring(4));
        // console.log(query);
        const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/environnement_webs?' + query, {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": this.$store.state.storeGlobal.StoreJwtToken
          },
        })
        // console.log(res);
        var resultApi = (await res.json());
    //console.log(resultApi);
        //etat environnement tru ou false
        this.etatEnv = resultApi[0]['etat'];
        this.$store.state.storeGlobal.StorePays = resultApi[0]['pays']
        this.$store.state.storeGlobal.StoreEnvWeb = resultApi[0]['nom']
        this.$store.state.storeGlobal.contactForm = JSON.parse(this.$CryptoJS.AES.decrypt(resultApi[0]['encodedContact'], process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)) 

        //console.log(this.$store.state.storeGlobal);

 //Si il existe un configrateur fibre alors fiicher le lien avant de faire apparaitre le configurateur
 if(resultApi[0]['autre_config'] != null){
          this.chooseConfig = false;
          this.autreConfigUrl = resultApi[0]['autre_config'];
        }

        // console.log(resultApi);
        //etat chargement de la page
        this.load = false;
        // console.log("test");
      } catch (error) {
        // console.log(document.location.ancestorOrigins);
        // console.log('Error! Could not reach the API. ' + error);
        this.answer = 'Error! Could not reach the API .' + error
      }
    },

    setUser(event) {

      if (typeof event.data.user != "undefined") {

        this.$store.commit('SET_USER', event.data.user)
        //const source = JSON.parse(this.$CryptoJS.AES.decrypt(event.data.user, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).source

        // console.log(JSON.parse(this.$CryptoJS.AES.decrypt(event.data.user, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)))
        //this.$store.commit('PUT_ENV_WEB', source)
        //this.initLanguage();

      }

    },
    async initLanguage() {


      //Condition par pays
      //console.log(this.$store.state.storeUser);
      if (this.$store.state.storeUser.user != null) {
        //console.log(this.$store.state.storeUser);
        console.log(JSON.parse(this.$CryptoJS.AES.decrypt(this.$store.state.storeUser.user, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)))
        var lang = JSON.parse(this.$CryptoJS.AES.decrypt(this.$store.state.storeUser.user, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).lang
        var pays = JSON.parse(this.$CryptoJS.AES.decrypt(this.$store.state.storeUser.user, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).pays

        this.$i18n.locale = lang.toLowerCase();
        this.$store.state.storeUser.lang = lang.toLowerCase();
        this.$store.state.storeGlobal.StorePays = pays.toUpperCase()
     
      }
      else {
        if (this.$store.state.storeGlobal.StorePays == 'FR') {
          this.$i18n.locale = 'fr';
          this.$store.state.storeUser.lang = 'fr'
          //console.log(this.$i18n.locale);
        }
        if (this.$store.state.storeGlobal.StorePays == 'NL') {
          this.$i18n.locale = 'nl';
          this.$store.state.storeUser.lang = 'nl'
          //console.log(this.$i18n.locale);
        }
        if (this.$store.state.storeGlobal.StorePays == 'SE') {
          this.$i18n.locale = 'sv';
          this.$store.state.storeUser.lang = 'sv'
          //console.log(this.$i18n.locale);
        }
        if (this.$store.state.storeGlobal.StorePays == 'IT') {
          this.$i18n.locale = 'it';
          this.$store.state.storeUser.lang = 'it'
          //console.log(this.$i18n.locale);
        }
        if (this.$store.state.storeGlobal.StorePays == 'FI') {
          this.$i18n.locale = 'fi';
          this.$store.state.storeUser.lang = 'fi'
          //console.log(this.$i18n.locale);
        }
        if (this.$store.state.storeGlobal.StorePays == 'CH') {
          this.$i18n.locale = 'de';
          this.$store.state.storeUser.lang = 'de'
          //console.log(this.$i18n.locale);
        }
        if (this.$store.state.storeGlobal.StorePays == 'IE') {
          this.$i18n.locale = 'en';
          this.$store.state.storeUser.lang = 'en'
          //console.log(this.$i18n.locale);
        }

      }


    }
 
},

  
}
</script>


